(function($){

    $('document').ready(function() {

        $('.burger').on('click', function() {
            $('.mobile-nav').toggle();
        });

        var dropdown = jQuery('.mobile-nav svg');
        var i;

        for (i = 0; i < dropdown.length; i++) {
            dropdown[i].addEventListener("click", function() {
                var dropdownContent = this.nextElementSibling;
                this.parentElement.classList.toggle("active");
                if (dropdownContent.style.display === "block") {
                    dropdownContent.style.display = "none";
                } else {
                    dropdownContent.style.display = "block";
                }
            });
        }

        // Store the window width
        var windowWidth = $(window).width();

        $(window).on('resize', function() {

            // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
            if ($(window).width() != windowWidth) {

                windowWidth = $(window).width();

                if ( $('.mobile-nav').is(':visible') ) {
                    $('.mobile-nav').toggle();
                }

            }
            
        });

    });

})(jQuery);